import styled from 'styled-components';
import { BREAKPOINT_MEDIUM } from 'global-search-shared';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSVG = styled.svg.withConfig({
  displayName: "SearchIcon__StyledSVG",
  componentId: "sc-105oqge-0"
})(["width:16px;height:16px;fill:var(--search-icon-fill);transition:fill 0.1s ease-in !important;position:absolute;top:50%;transform:translateY(-50%);left:", ";pointer-events:none;z-index:2;@media (max-width:", "px){left:", ";}"], ({
  theme
}) => theme.space['500'], BREAKPOINT_MEDIUM - 1, ({
  theme
}) => theme.space['300']);
export const SearchIcon = () => {
  return /*#__PURE__*/_jsx(StyledSVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0",
    y: "0",
    viewBox: "0 0 31 31",
    xmlSpace: "preserve",
    width: "14px",
    display: "flex",
    children: /*#__PURE__*/_jsx("g", {
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-116.000000, -3779.000000)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M127.7,3799.4c-4.8,0-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7 C136.4,3795.5,132.5,3799.4,127.7,3799.4 M146.1,3806.9l-9.1-9.1c1.5-2,2.4-4.4,2.4-7.1c0-6.4-5.2-11.7-11.7-11.7 c-6.4,0-11.7,5.2-11.7,11.7c0,6.4,5.2,11.7,11.7,11.7c2.7,0,5.2-0.9,7.1-2.4l9.1,9.1c0.3,0.3,0.7,0.4,1.1,0.4 c0.4,0,0.8-0.1,1.1-0.4C146.6,3808.5,146.6,3807.5,146.1,3806.9"
        })
      })
    })
  });
};